import type { RuleHandler } from "../types";
import { setIncludes } from "../setIncludes";

const checkAllMarketTypeNamesMustMatch: RuleHandler = (
  context,
  requirement,
) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  if (
    !setIncludes(
      new Set(requirementAttributes?.marketTypeNames),
      new Set(context.selection.marketTypes),
      requirementAttributes?.allMarketTypeNamesMustMatch || false,
    )
  ) {
    return false;
  }

  return true;
};

export { checkAllMarketTypeNamesMustMatch };
